export const homeCopy = {
  badge: "n8n · AI Agent · Automation · SaaS",
  titleLead: "Belajar",
  titleAccent: "automation & AI",
  titleTail: "dari praktisi.",
  description:
    "Kelas, ebook, dan workflow siap pakai berbahasa Indonesia untuk n8n, AI agent, automation, dan membangun SaaS — langsung bisa dipraktikkan.",
  primaryCta: "Lihat katalog",
  secondaryCta: "Baca tutorial gratis",
  topicDescriptions: {
    n8n: "Workflow, webhook, integrasi API, dan chatbot dengan n8n.",
    "ai-agent": "AI agent & chatbot yang terhubung ke data dan tool bisnis.",
    automation: "Otomatiskan laporan, notifikasi, CRM, dan invoice.",
    saas: "Bangun produk SaaS dengan AI dan pembayaran.",
    "vibe-coding": "Bikin aplikasi dari nol dengan AI coding tools.",
    hermes: "Hermes Agent untuk automation dan AI agent.",
    openclaw: "OpenClaw untuk AI agent pribadi.",
  },
} as const;
